import React from "react";

import "./footer.css";

const Footer = (props) => {
  return (
    <footer className="footer-footer">
      <div className="footer-container">
        <div className="footer-container1">
          <span className="footer-text">
            MabiVCC - Mabinogi Visual Chat Converter
          </span>
          <span>Created and maintained by svn</span>
        </div>
        <div className="footer-container2">
          <div className="footer-container3"></div>
          <div className="footer-container4">
            <span className="footer-text06 Large">Related Content</span>
            <span className="footer-text07 Large">
              <a href="https://auranogi.wiki/">Auranogi</a>
            </span>
            <span className="footer-text08 Large">
              <a href="http://mabi.pro/">MabiPro</a>
            </span>
            <span className="footer-text09 Large">
              <a href="http://tozino.fun/">Tozino</a>
            </span>
          </div>
          <div className="footer-container5">
            <span className="footer-text10 Large">Resources</span>
            <span className="footer-text11 Large">
              <a href="https://github.com/ryuugana/mabi-vcc">Git</a>
            </span>
            <span className="footer-text12 Large">
              <a href="https://pngquant.org/">pngquant</a>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
